import L from 'leaflet';
import './TrueSizePolygon';
import {createElementObject, createPathComponent, extendContext} from "@react-leaflet/core";



export const TrueSize = createPathComponent(
  function createPolygon({ positions, ...options }, ctx) {
    let coordinates = positions;
    let type = (coordinates.length > 1) ? 'MultiPolygon' : 'Polygon';
    if (type === 'MultiPolygon') {
      coordinates = [coordinates];
    }
    let geojson = {
      type: 'Feature',
      properties: {},
      geometry: {
        type: type,
        coordinates: coordinates,
      }
    };
    const polygon = L.trueSizePolygon(geojson, options);

    return createElementObject(
      polygon,
      extendContext(ctx, { overlayContainer: polygon }),
    )
  },
  function updatePolygon(layer, props, prevProps) {
    if (props.positions !== prevProps.positions) {
      layer.setLatLngs(props.positions)
    }
  },
)

export default TrueSize;
